<template>
  <div class="list-container">
    <div class="item" v-for="item in data" :key="item.distributorId">
      <div class="item-l">
        <div
          class="avatar"
          :style="{ backgroundImage: 'url(' + avatar_c(item.headImg) + ')' }"
        ></div>
        <div class="text">
          <div class="title">{{ item.distributorName }}</div>
          <div class="level">
            <span>{{ item.rankName }}</span>
          </div>
        </div>
      </div>
      <div class="item-r">
        <div class="amount">¥{{ item.accumulatedIncome }}</div>
        <div class="label">总销售额</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    avatar_c() {
      return function (avatar) {
        return avatar || require('@/assets/setting/avatar.png')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.list-container {
  padding: 0 24px;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 30px 24px;
    .item-l {
      display: flex;
      align-items: center;
      .avatar {
        width: 104px;
        height: 104px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 100%;
      }
      .text {
        padding-left: 24px;
        .title {
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        .level {
          padding-top: 16px;
          line-height: 34px;
          span {
            color: #e82035;
            font-size: 22px;
            line-height: 1em;
            display: inline-block;
            background: #fef2f3;
            padding: 6px 16px;
            border-radius: 34px;
            border: 1px solid #e82035;
          }
        }
      }
    }
    .item-r {
      text-align: right;
      .amount {
        font-size: 32px;
        font-family: Verdana;
        color: #333333;
        line-height: 32px;
      }
      .label {
        padding-top: 16px;
        font-size: 22px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
    }
  }
}
</style>